import { Component, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { iconColors, iconSizes } from '@app/shared/constants';

@Component({
  selector: 'cross',
  templateUrl: 'cross.component.html',
  styleUrls: ['cross.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CrossComponent {
  @Input()
  @HostBinding('class.no-margin')
  public noCrossMargin: boolean;

  @Input()
  autId: string;

  @Input()
  iconTitle = 'Close';

  @Input()
  @HostBinding('class.change-on-hover')
  public changeOnHover: boolean;

  @Input()
  public colorClassName: string = iconColors.BLACK;

  @Input()
  public crossSize = iconSizes.DEFAULT;

  public iconColors = iconColors;
}
